module.exports = __webpack_public_path__ + "img/source03_m3.95f7d16a.png";